import React from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
// @ts-ignore
import ReactTable from 'react-table';
import {
  Col,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import Filters from '../../../components/Filters/Filters';
import PaginationTable from '../../../components/Pagination/PaginationTable';
import getSortHeaderProps from '../../../utils/get-sorted-headers';
import { showConfirmModal } from '../../../modules/modals/confirmService';
import {
  WithTranslation,
  withTranslation,
} from 'react-i18next';
import ManualAddStore from '../../../stores/manual-add-store';
import logger from '../../../utils/logger';

interface ComponentProps extends WithTranslation {
  manualAddStore: ManualAddStore;
  onDelete: () => void;
  onEdit: () => void;
  t: (key: string) => string;
}

interface ComponentState {
  sorted: Array<any>;
  filter: string;
  selected: number | null;
}

class ManualAddTable extends React.Component<ComponentProps, ComponentState> {
  constructor(props: any) {
    super(props);
    this.state = {
      sorted: [{ id: 'extraProductItemCode', desc: false }],
      filter: '',
      selected: null,
    };
  }

  componentDidMount() {
    const { manualAddStore} = this.props;

    if (!manualAddStore.manualAddList.length) {
      manualAddStore.loadManualAddList();
    }
  }

  onEdit = (id: number) => {
    const { manualAddStore, onEdit } = this.props;
    manualAddStore.selectManualAdd(Number(id));
    onEdit();
  };

  onDelete = async (id: number, code: string) => {
    const { manualAddStore, onDelete, t } = this.props;

    try {
      await showConfirmModal({
        title: `${t('Are you sure you want to delete')} ${code}?`,
        okLabel: t('Yes'),
        cancelLabel: t('No'),
        enableEscape: false,
      });

      onDelete();

      await manualAddStore.removeManualAdd(Number(id));
      await manualAddStore.loadManualAddList();
    } catch (error) {
      logger.error(error);
    }
  };

  getColumns = () => {
    const { sorted } = this.state;
    const { t } = this.props;

    return [
      {
        headerText: t('Code'),
        accessor: 'extraProductItemCode',
        id: 'extraProductItemCode',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
        maxWidth: 120,
      },
      {
        headerText: t('Description'),
        accessor: 'extraProductItemDescription',
        id: 'extraProductItemDescription',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Unit'),
        accessor: 'unitSymbol',
        id: 'unitSymbol',
        ...getSortHeaderProps(sorted),
      },
      {
        accessor: 'actions',
        maxWidth: 120,
        Cell: (row: any) => (
          <div className="text-right">
            <a className="btn btn-sm btn-default btn-action"
              title="Edit"
              onClick={() => this.onEdit(row.original.extraProductItemId)}>
              <i className="fa fa-pencil"/>
            </a>
            <a className="btn btn-sm btn-default btn-action"
              title="Remove"
              onClick={() => this.onDelete(row.original.id, row.original.extraProductItemCode)}>
              <i className="fa fa-remove"/>
            </a>
          </div>
        ),
      },
    ];
  };

  handleChange = (e: any) => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  render() {
    const { manualAddStore, t } = this.props;
    const { manualAddList } = manualAddStore;
    const { filter } = this.state;

    const onRowClick = (state: any, rowInfo: any) => {
      if (rowInfo?.row) {
        return {
          onClick: () => {
            this.onEdit(rowInfo.original.extraProductItemId);
            this.setState({
              selected: rowInfo.index,
            });
          },
          className: rowInfo.index === this.state.selected ? 'row-selected': '',
        };
      }
      return {};
    };

    return (
      <div className={`adjusted-mixes-${manualAddList.length}`}>
        <Col sm={4} xs={10} className={'no-padding'}>
          <FormGroup>
            <FormControl
              type="text"
              value={filter}
              placeholder={t('Search')}
              onChange={this.handleChange}
            />
          </FormGroup>
        </Col>
        <Filters filter={filter} data={manualAddList} renderData={(items: any) => (
          <ReactTable
            className="-highlight mix-table"
            data={items}
            columns={this.getColumns()}
            sorted={this.state.sorted}
            onSortedChange={(sorted: any) => this.setState({ sorted })}
            showPaginationTop={false}
            showPaginationBottom={true}
            showPageSizeOptions={true}
            PaginationComponent={PaginationTable}
            resizable={false}
            minRows={1}
            defaultPageSize={100}
            getTrProps={onRowClick}
          />
        )} />
      </div>
    );
  }
}

export default withTranslation()(inject('manualAddStore')(observer(ManualAddTable)));
